import { Controller } from "@hotwired/stimulus"
import rememberGuestFavourite from "@/frontend/utils/rememberGuestFavourite"

// Opens the sign-in/up modal when a guest taps a favourite heart, remembering
// the artwork so it gets favourited once they authenticate.
export default class extends Controller {
  static values = {
    listingId: Number,
    title: { type: String, default: "Login to favourite artworks" },
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    rememberGuestFavourite(this.listingIdValue)
    document.dispatchEvent(
      new CustomEvent("show-session-modal", { detail: { title: this.titleValue } }),
    )
  }
}
